import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/public/credentials-groups`

export async function validatePassword(body: {
  unique_string: string
  password: string
}) {
  return axios.post(
    `${URL}/validate-password`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function postCredentials(body: {
  unique_string: string
  password: string
  credentials: { id: string; value: string }[]
}) {
  return axios.post(
    `${URL}/set-credentials`,
    { data: body },
    parseAuthenticationHeader()
  )
}
